const initialState = {
  btnLoaderOne: false,
  adminView: 'customer',
};

export function ProductReducer(state = initialState, action) {
  switch (action?.type) {
    case 'ALL_PRODUCTS':
      return {
        ...state,
        allProducts: [...action?.payload],
      };
    case 'TOP_FOUR_PRODUCTS':
      return {
        ...state,
        topFourProducts: [...action?.payload],
      };
    case 'USER_SHOP_FILTERS':
      return {
        ...state,
        userShopFilters: { ...action?.payload },
      };
    case 'SINGLE_PRODUCT_DETAILS':
      return {
        ...state,
        productDetails: { ...action?.payload },
      };

    case 'ALL_BLOGS':
      return {
        ...state,
        blogs: [...action?.payload],
      };

    case 'ALL_PINCODES':
      return {
        ...state,
        pincodes: [...action?.payload],
      };

    default:
      return state;
  }
}
